'use strict';
IS_EXTENSION = false;
TRES_HOLD = 50;

import {LitElement, html} from 'lit-element';
import { repeat } from 'lit-html/directives/repeat';


class VirtualPet extends LitElement {

  constructor() {
    super();
    this.petState=this.petStates[0].Name;
    this.isExt = IS_EXTENSION;
    this.petCurrImg = "data/loading.gif";
    this.isAnimationPresent = false;
    this.isPuppet = false;
    this.petAlive = true;
    this.isLoaded = false;
    this.isPopupMode = true;
    this.isHome = false;
    this.petAge = 1;
  }


  static get properties() {
    return {
      isExt:{type:Boolean, reflectToAttribute: false, noAccessor: true},
      petName: {type:String, reflect:true},
      petCategory: {type:String},
      petStates:{type:Array},
      petState:{type:String},
      petHealthMax: {type:Number},
      petHealthMaxInit: {type:Number, reflect:true},
      petHealthLevel:{type:Number, reflect:true},
      petHealthLevelExp:{type:Number, reflect:true},
      pulseHealth:{type:Number, reflect:true},
      petFoodLevel:{type:Number, reflect:true},
      petFoodLevelExp:{type:Number, reflect:true},
      pulseFood:{type:Number, reflect:true},
      petSleepLevel:{type:Number, reflect:true},
      petSleepLevelExp:{type:Number, reflect:true},
      pulseSleep:{type:Number, reflect:true},
      petPlayLevel:{type:Number, reflect:true},
      petPlayLevelExp:{type:Number, reflect:true},
      pulsePlay:{type:Number, reflect:true},
      petAlive:{type:Boolean, reflect:true, attribute:true },
      petVisualPath:{type:String},
      petHappyImg:{type:String},
      petSickImg:{type:String},
      petSleepImg:{type:String},
      petDiedImg:{type:String},
      petCurrImg:{type:String},
      liveInterval:{type:Number, reflect:false},
      foodInterval:{type:Number, reflect:false},
      playInterval:{type:Number, reflect:false},
      sleepInterval:{type:Number, reflect:false},
      healthInterval:{type:Number, reflect:false},
      isSleeping:{type:Boolean, reflect:true},
      lastGym:{type:Number, reflect:true},
      lastGymDecrease:{type:Number, reflect:true},
      liveinDate:{type:Number, reflect:true},
      liveTime:{type:String, reflect:true},
      isPuppet:{type:Boolean, reflect:true},
      feedUrl:{type:String},
      playUrl:{type:String},
      sleepUrl:{type:String},
      awakeUrl:{type:String},
      gymUrl:{type:String},
      categoryId:{type:Number},
      itemId:{type:Number},
      isLoaded:{type:Boolean, reflect:true},
      isPopupMode:{type:Boolean, reflect:true},
      isAnimationPresent:{type:Boolean, reflect:true},
      petSickAn:{type:String},
      petSleepAn:{type:String},
      petHappyAn:{type:String},
      petCurrAn:{type:String},
      isHome:{type:Boolean, reflect:true},
      petAge:{type:Number}
    };
  }

  get petStates() {
    return [
      {id:0, Name:"Happy"}
      ,{id:1, Name:"Sick"}
      ,{id:2, Name:"Died"}
    ];
  }

  render() {
    return html`<style>
@import "/css/bootstrap.min.css";   
@import "/css/fontawessome.css";
@import "/css/pie-progress.css";
@import "/css/virtual-pet.css";

:host {
  display: block;
  padding: 10px;
  width: 100%;
  height: 100%;
}
:host([hidden]) {
  display: none;
}
</style>

<div id="petEnv" class="${this.isHome?"home-page":""}">
    <div class="pet-container">
        
        <div class="wrapper">
          <div class="application">
            <div class="header ${this.isExt?"ext-header":""}">
              ${this._helpRules()}
              <div class="live-time">${this.isExt ? chrome.i18n.getMessage("text_14") : "Live time:"} ${this.liveTime}</div>
              <div class="user">
                ${this._petVisualization()}
                <div class="time">00:00</div>
                <div class="nickname">
                  <div class="petDetails ${this.petState} text-center">
                    <span class="badge"><b>${this.petName}</b></span>  
                    <span class="badge">${this.petState}</span> 
                    ${this.isSleeping ? html` <span class='badge'>${this.isExt ? chrome.i18n.getMessage("text_3") : "Sleeping"}</span>` : ""}
                  </div>
                </div>
              </div>
              ${this.isExt?
                html`
                <div class="friends">
                  <div class="${this.isPopupMode ? 'feed-controls-popup' : 'feed-controls'}">
                    
                    <div id="btnFeed" role="button" 
                      class="feedBtn button food cornered" 
                      title="${this.isExt ? chrome.i18n.getMessage("text_4") : "Feed your pet for up level of food"}" 
                      @click="${(e) => this.handleFeed(this.feedUrl)}">
                      <i class="fas fa-bone fa-rotate-45"></i>
                      <div class="label">
                        ${this.isExt ? chrome.i18n.getMessage("btn_1") : "FEED"}
                      </div>
                    </div>
                    <div id="btnPlay" role="button" 
                      class="feedBtn button play cornered" 
                      title="${this.isExt ? chrome.i18n.getMessage("text_5") : "Play with your pet for up level of play"}" 
                      @click="${(e) => this.handleFeed(this.playUrl)}">
                      <i class="fas fa-running"></i>
                      <div class="label">
                      ${this.isExt ? chrome.i18n.getMessage("btn_2") : "PLAY"}
                      </div>
                    </div>
                    <div id="btnAwake" role="button" class="feedBtn button awake cornered" 
                        title="${this.isExt ? chrome.i18n.getMessage("text_6") : "Wake up your pet"}" 
                        style="${this.isSleeping ? 'display:block' : 'display:none'}"
                        @click="${(e) => this.handleFeed(this.awakeUrl)}">
                      <i class="fas fa-bell"></i>
                      <div class="label">
                        ${this.isExt ? chrome.i18n.getMessage("btn_3") : "WAKE UP"}
                        
                      </div>
                    </div>
                    <div id="btnSleep" role="button" class="feedBtn button sleep cornered" 
                      title="${this.isExt ? chrome.i18n.getMessage("text_7") : "Let your pet rest"}" 
                      style="${!this.isSleeping ? 'display:block' : 'display:none'}"
                      style="display:none" @click="${(e) => this.handleFeed(this.sleepUrl)}">
                      <i class="fas fa-bed"></i>
                      <div class="label">
                        ${this.isExt ? chrome.i18n.getMessage("btn_4") : "SLEEP"}
                        
                      </div>
                    </div>
                    <div id="btnGym" role="button" class="feedBtn button gym cornered " 
                      title="${this.isExt ? chrome.i18n.getMessage("text_8") : "Take your pet to the gym to improve it health level."}" 
                      @click="${(e) => this.handleFeed(this.gymUrl)}">
                      <div class="back-time">00:00:00</div>
                      <i class="fas fa-dumbbell fa-rotate-45"></i>
                      <div class="label">
                        ${this.isExt ? chrome.i18n.getMessage("btn_5") : "GYM"}
                        
                      </div>
                    </div>
                  </div>
                </div>                
              `:html``
              }
              <div class="wrap-died ${!this.isExt?"full-height":""}" style="display:none;">
                <i class="fas fa-skull-crossbones"></i>
              </div>
              ${this.isLoaded
                ?html``
                :html`              
                  <div class="wrap-loading" style="display:block;">
                    <i class="fas fa-spinner fa-spin"></i>
                    <span class="label">
                      ${this.isExt ? chrome.i18n.getMessage("btn_5") : "Loading..."}
                      
                    </span>
                  </div>
                  `
              }

            </div>
            <div class="content">
              <div class="tabs">
                <div class="tab">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="vertical-progress-container vertical flat">
                        <div class="progress-bar">
                          <div class="progress-track">
                            <div class="progress-fill">
                              <span style="font-size:0">${this.petFoodLevel}%</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9">
                      <div class="label">
                        Food
                      </div>
                      <div class="count">
                        <div class="food">
                          <i class="fas fa-bone fa-rotate-45"></i>
                          <div class="food-rate">
                            ${this.petFoodLevel}%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                <div class="tab">

                  <div class="row">
                    <div class="col-md-3">
                      <div class="vertical-progress-container vertical flat">
                        <div class="progress-bar">
                          <div class="progress-track">
                            <div class="progress-fill">
                              <span style="font-size:0">${this.petPlayLevel}%</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9">
                      <div class="label">
                        Play
                      </div>
                      <div class="count">
                        <div class="play">
                          <i class="fas fa-running"></i>                
                          <div class="play-rate">
                            ${this.petPlayLevel}%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab">

                  <div class="row">
                    <div class="col-md-3">
                      <div class="vertical-progress-container vertical flat">
                        <div class="progress-bar">
                          <div class="progress-track">
                            <div class="progress-fill">
                              <span style="font-size:0">${this.petSleepLevel}%</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9">
                      <div class="label">
                        Sleep
                        </div>
                        <div class="count">
                          <div class="sleep">
                            <i class="fas fa-bed"></i>
                            <div class="sleep-rate">
                              ${this.petSleepLevel}%
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>                

              </div>
              ${this._petControls()}
            </div>
          </div>
        </div>        

        
    </div>
  </div>
  `;
  }

  firstUpdated() {
    var that = this;
     
    this.shadowRoot.querySelectorAll("#petEnv").forEach(function(el){
        // this part working only in direct placed component mode, i.e. valid for isExt = false
        window.addEventListener("load", function(){

          that.liveInterval = setInterval(() => {
            if(that.liveTime){
              let initDate = that.liveinDate;
              let currDate = (new Date()).getTime();
              that.liveTime = that._MillisecondsToDuration(currDate-initDate);
            }
            else{
              that.liveTime =  that._MillisecondsToDuration(1000)
            }
            let event = new CustomEvent('live-pulse', {
              detail: {
                message: `Live pulse`
              }
            });
            that.dispatchEvent(event);            

          }, 1000);

          that.foodInterval = setInterval(() => {
            that.pulseFood = that.getFoodPulse() + that.getFoodPulseStep();
            that.petFoodLevelExp = that.getFoodLevelExp();
            that.petFoodLevel = Math.round(that.petFoodLevelExp);
            /*let event = new CustomEvent('food-level-event', {
              detail: {
                message: `Food level changed`
              }
            });
            that.dispatchEvent(event);*/

          }, that.getFoodPulseStep() * 1000);

          that.playInterval = setInterval(() => {
            if(!that.isSleeping){
              that.pulsePlay = that.getPlayPulse() + that.getPlayPulseStep();
            }
            that.petPlayLevelExp = that.getPlayLevelExp();
            that.petPlayLevel = Math.round(that.petPlayLevelExp);
            /*let event = new CustomEvent('play-level-event', {
              detail: {
                message: `Play level changed`
              }
            });
            that.dispatchEvent(event);*/

          }, that.getPlayPulseStep() * 1000);

          that.sleepInterval = setInterval(() => {
            if(that.isSleeping){
              that.pulseSleep = that.getSleepPulse() - that.getSleepPulseStep();
            }
            else{
              that.pulseSleep = that.getSleepPulse() + that.getSleepPulseStep();
            }

            that.petSleepLevelExp = that.getSleepLevelExp();
            that.petSleepLevel = Math.round(that.petSleepLevelExp);
          /*let event = new CustomEvent('sleep-level-event', {
              detail: {
                message: `Sleep changed`
              }
            });
            that.dispatchEvent(event);*/

          }, that.getSleepPulseStep() * 1000);

          that.healthInterval = setInterval(() => {
            that._calculateHealth()
          }, that.getHealthPulseStep() * 1000);

          that._calculateProgress();

          if(!that.isExt){
            var btnSleep = that.shadowRoot.querySelector("#btnSleep");
            var btnFeed = that.shadowRoot.querySelector("#btnFeed");
            var btnPlay = that.shadowRoot.querySelector("#btnPlay");
            var btnGym = that.shadowRoot.querySelector("#btnGym");
            var btnAwake = that.shadowRoot.querySelector("#btnAwake");
            
            if(that.isSleeping){
              $(btnSleep).hide();
              $(btnFeed).attr("disabled","disabled");
              $(btnPlay).attr("disabled","disabled");
              $(btnGym).attr("disabled","disabled");
              $(btnAwake).show();
            }
            else{
              $(btnSleep).show();
              $(btnFeed).removeAttr("disabled");
              $(btnPlay).removeAttr("disabled");
              if(that.canGym()){
                $(btnGym).removeAttr("disabled");
              }
              $(btnAwake).hide();

            }
  
            btnSleep.addEventListener("click", function (){
              that.isSleeping = true;
              $(btnSleep).hide();
              $(btnFeed).attr("disabled","disabled");
              $(btnPlay).attr("disabled","disabled");
              $(btnGym).attr("disabled","disabled");
              $(btnAwake).show();
              let event = new CustomEvent('sleep-event', {
                detail: {
                  message: `Sleep clicked`
                }
              });
              that.dispatchEvent(event);
            });
            
            btnAwake.addEventListener("click", function(){
              that.isSleeping = false;
              $(btnSleep).show();
              $(btnFeed).removeAttr("disabled");
              $(btnPlay).removeAttr("disabled");
              if(that.canGym()){
                $(btnGym).removeAttr("disabled");
              }
              $(btnAwake).hide();
              let event = new CustomEvent('awake-event', {
                detail: {
                  message: `Awake clicked`
                }
              });
              that.dispatchEvent(event);

            });
            btnGym.addEventListener("click", function(){
              let disabled = $(this).attr("disabled");
              if(disabled){return;}

              if(that.canGym()){
                that.lastGym = (new Date()).getTime();
                that.lastGymDecrease = that.lastGym; // new age
                if((that.petHealthMax + that.petHealthMaxInit/10) <= that.petHealthMaxInit*2){
                  that.petHealthMax += that.petHealthMaxInit/10;
                }
                else{
                  that.petHealthMax = that.petHealthMaxInit*2;
                }
                let event = new CustomEvent('gym-event', {
                  detail: {
                    message: `Gym clicked`
                  }
                });
                that.dispatchEvent(event);
                  
                $(btnGym).attr("disabled", "disabled");
              }
            });
            btnFeed.addEventListener("click", function(){
              let disabled = $(this).attr("disabled");
              if(disabled){return;}
              let before = that.petFoodLevel;
              if(that.petFoodLevel+that.petHealthMaxInit/10<100){
                that.petFoodLevel+=that.petHealthMaxInit/10;
                that.petFoodLevelExp = that.petFoodLevel;
                that.pulseFood = that.getPlayPulse();
              }
              else{
                that.petFoodLevel=100;
                that.petFoodLevelExp = 99.6;
                that.pulseFood = 3;
              }

              let event = new CustomEvent('feed-event', {
                detail: {
                  message: `Feed clicked`
                }
              });
              that.dispatchEvent(event);
              if(before < that.petFoodLevel){
                let upLevel = $(this).find(".tip-up-level");
                if (upLevel.css('opacity') == 0) {
                  upLevel.css('opacity', 1);
                  setTimeout(function(){
                    upLevel.css('opacity', 0);
                  },500);
                }
                else {
                    upLevel.css('opacity', 0);
                }
  
              }
            
            });
            btnPlay.addEventListener("click", function(){
              let disabled = $(this).attr("disabled");
              if(disabled){return;}
              let before = that.petPlayLevel;
              if(that.petPlayLevel+that.petHealthMaxInit/10<100){
                that.petPlayLevel+=that.petHealthMaxInit/10;
                that.petPlayLevelExp = that.petPlayLevel;
                that.pulsePlay = that.getPlayPulse();

              }
              else{
                that.petPlayLevel=100;
                that.petPlayLevelExp=99.6;
                that.pulsePlay = 3;
              }
              let event = new CustomEvent('play-event', {
                detail: {
                  message: `Play clicked`
                }
              });
              that.dispatchEvent(event);

              if(before < that.petPlayLevel){
                let upLevel = $(this).find(".tip-up-level");
                if (upLevel.css('opacity') == 0) {
                  upLevel.css('opacity', 1);
                  setTimeout(function(){
                    upLevel.css('opacity', 0);
                  },500);
                }
                else {
                    upLevel.css('opacity', 0);
                }
  
              }

              
            });
          }

  
        });
        // common part, valid in any mode
          

        that.petCurrImg = that.isSleeping ? that.petSleepImg : that.petHappyImg;
        that.shadowRoot.querySelectorAll('[data-fancybox]').forEach(function(fEl){    
          $(fEl).fancybox();
        });

        var btnBackFromHelp = that.shadowRoot.querySelector(".back-to-pet");
        var help = that.shadowRoot.querySelector(".wrap-help");
        var helpBtn = that.shadowRoot.querySelector(".help-rules");
        btnBackFromHelp.addEventListener("click",function(){
          $(help).hide();
          $(helpBtn).show();
        });
        helpBtn.addEventListener("click",function(){
          $(help).show();
          $(helpBtn).hide();
        });

        if(!that.petHealthLevel && !that.isExt){
          that.petHealthMaxInit = that.petHealthMax;
          that.petHealthLevel = (that.petHealthMax/that.petHealthMax)*100;
          that.petFoodLevel = (that.petHealthMax/that.petHealthMax)*100;
          that.petSleepLevel = (that.petHealthMax/that.petHealthMax)*100;
          that.petPlayLevel = (that.petHealthMax/that.petHealthMax)*100;
        }
        var timeEl = $(el).find(".time");
        $(timeEl).html(that._MillisecondsToDuration(that.petHealthLevel * (that.petHealthMax/100) * 1000))


    });  


    this._updatePromise.then(res=>{
      //debugger;
      if(!that.isPuppet){
        //var wrapper = that.shadowRoot.querySelector(".wrap-loading");
        setTimeout(function(){
          /*if(!that.petHealthLevel){
            that.petHealthMaxInit = that.petHealthMax;
            that.petHealthLevel = (that.petHealthMax/that.petHealthMax)*100;
            that.petFoodLevel = (that.petHealthMax/that.petHealthMax)*100;
            that.petSleepLevel = (that.petHealthMax/that.petHealthMax)*100;
            that.petPlayLevel = (that.petHealthMax/that.petHealthMax)*100;
          }          
  
          that.loadedShow();*/
          that._calculateVisualAge();
          that._calculateHealth();
          that.checkAnimation();
          
        }, 500);
      }
    });
  }

  _petVisualization() {
    if(this.isAnimationPresent){
      return html`
        <div class="hearth">
          <div class="progress--circle progress--${this.petHealthLevel}">
            <div class="feature-preview-box">
              <div id="animeContainer">
                <div class="ava" style="background: url('${this.petCurrImg}') center center / cover no-repeat;background-size:100% 100%;"></div>
              </div>
              <div class="rate progress__number" style="border: 1px solid #ff7141;border-radius: 50%;background-color: #0fe820;padding-top: 8px;width: 30px;height: 30px;top: 1px;left: 73px;">
                ${this.petAge}
              </div>
              <div class="rate progress__number" style="border: 1px solid #ff7141;border-radius: 50%;background-color: #63B8FF;padding-top: 15px;width:50px;height: 50px;top: 125px;left: 125px;">
                <div class="icon"></div>
                ${this.petHealthLevel}%
              </div>
            </div>
            
          </div>
        </div>

      `;
  
    }
    else{
      return html`
        <div class="hearth">
          <div class="progress--circle progress--${this.petHealthLevel}">
            <div class="feature-preview-box">
              <a data-fancybox="images" href="${this.petCurrImg}">
                  <div class="ava" style="background: url('${this.petCurrImg}') center center / cover no-repeat;background-size:100% 100%;">
                    <div class="rate progress__number" style="border: 1px solid #ff7141;border-radius: 50%;background-color: #63B8FF;padding-top: 15px;width:50px;height: 50px;top: 125px;left: 125px;">
                      <div class="icon"></div>
                      ${this.petHealthLevel}%
                    </div>
        
                  </div>
              </a>
            </div>
            
          </div>
        </div>
      `
  
    }
  }

  _petControls(){
    if (this.isExt) {
      if(this.petAlive){
        return html`
          <div class="message-bottom">
            ${this.isExt ? chrome.i18n.getMessage("text_10_1") : "Keep"}
            ${this.petName} 
            ${this.isExt ? chrome.i18n.getMessage("text_10_2") : "alive by feeding it, playing with it, and letting it sleep!"}
            
          </div>
        `;
      }
      else{
        return html`
          <center>
            <div class="message-bottom">
              <div class="died-msg">
                ${this.isExt ? chrome.i18n.getMessage("text_13_1") : "Your pet"} 
                <strong>${this.petName}</strong> 
                ${this.isExt ? chrome.i18n.getMessage("text_13_2") : "is died!"} 
              </div>
              <div id="btnMakeNew" role="button" class="feedBtn play cornered" 
                title="${this.isExt ? chrome.i18n.getMessage("text_11") : "Make new pet"}">
                <i class="fas fa-paw"></i>
                <div class="label">
                  ${this.isExt ? chrome.i18n.getMessage("btn_6") : "NEW!"}
                </div>
              </div>
            </div>
          </center>
          `;
      }
    } else {
      return html`
        <div class="friends">
          <div class="feed-controls">
            
            <div id="btnFeed" role="button" class="feedBtn food cornered" 
              title="Feed your pet for up level of food">
              <div class="tip-up-level">++!</div>
              <i class="fas fa-bone fa-rotate-45"></i>
              <div class="label">FEED</div>
            </div>
            <div id="btnPlay" role="button" class="feedBtn play cornered" title="Play with your pet for up level of play">
              <div class="tip-up-level">++!</div>
              <i class="fas fa-running"></i>
              <div class="label">PLAY</div>
            </div>
            <div id="btnAwake" role="button" class="feedBtn awake cornered" style="display:none" title="Awake your pet">
              <i class="fas fa-bell"></i>
              <div class="label">WAKE UP</div>
            </div>
            <div id="btnSleep" role="button" class="feedBtn sleep cornered" title="Let your pet rest">
              <i class="fas fa-bed"></i>
              <div class="label">SLEEP</div>
            </div>
            <div id="btnGym" role="button" class="feedBtn gym cornered " title="Take your pet to the gym to improve it health level.">
              <div class="back-time">00:00:00</div>
              <i class="fas fa-dumbbell fa-rotate-45"></i>
              <div class="label">GYM</div>
            </div>
          </div>
        </div>
      `;
    }
  }

  _helpRules(){
    if(this.isExt){

      return html`
      <div class="help-rules" style="display:block">
        <i class="fas fa-question-circle"></i>
      </div>
      <div class="wrap-help" style="display:none">
        <div class="back-to-pet">
          <i class="fas fa-arrow-right"></i>
        </div>
        <div class="spacer60"></div>
        <div class="row">
          <div class="col-md-2">
            <b>FEED</b>
          </div>
          <div class="col-md-10">
            <p>
              ${this.isExt ? chrome.i18n.getMessage("text_12") : "Keep"}
              <b>${this.petName}</b>. 
            </p>
            <p> 
              ${this.isExt ? chrome.i18n.getMessage("text_10_1") : "Keep"} 
              ${this.petName} 
              ${this.isExt ? chrome.i18n.getMessage("text_10_2") : "alive by feeding it, playing with it, and letting it sleep!"}
            </p>
          </div>
        </div>
      </div>
    `;
    }
    else{
      return html`
      <div class="help-rules" style="display:block">
        <i class="fas fa-question-circle"></i>
      </div>
      <div class="wrap-help" style="display:none">
        <div class="back-to-pet">
          <i class="fas fa-arrow-left"></i>
        </div>
        <div class="spacer60"></div>
        <div class="row">
          <div class="col-md-2">
            <b>HEALTH LEVEL</b>
          </div>
          <div class="col-md-10">
            <p>Your pet's health begins to decline when one or more of the parameters for food, play, or sleep reaches 60%. The more parameters reached 60%, then faster health is decreases.</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <b>FEED</b>
          </div>
          <div class="col-md-10">
            <p>The FEED button will feed your pet <b>${this.petName}</b>, the food level will increase with each press of the button, but not more than 100%. </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b>PLAY</b>
          </div>
          <div class="col-md-10">
            <p>A PLAY button will take your pet <b>${this.petName}</b> out for a walk, which will increase the level of PLAY, but not more than 100%. </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b>SLEEP</b>
          </div>
          <div class="col-md-10">
            <p>The sleep button will send your pet <b>${this.petName}</b> to bed, the pet will go to sleeping state, you cannot feed him at this time, play with him or go to the gym. The play level stops decreasing and the decrease in food slows down, the level of sleep increases, but not more than 100%. </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b>GYM</b>
          </div>
          <div class="col-md-10">
            <p>
            Each press of the GYM button increases the level of health of your pet by 10% and raises its level by 1, also your pet changes 
            its appearance, that is, grows. After pressing a button, you cannot press it for a period equal to your pet’s life. The next 
            press of the button again increases the life time by 10% and the level by 1. The maximum pet level is 8.
            </p>
          </div>
        </div>
      </div>
    `;      
    }
  }

  _calculateHealth(){
      
      let treshold = TRES_HOLD;
      let dangerFood = this.petFoodLevel < treshold;
      let dangerSleep = this.petSleepLevel < (treshold - 10);
      let dangerPlay = this.petPlayLevel < (treshold - 20);
      let loseH = 0;
      if(dangerFood){

        loseH++;
      }
      if(dangerSleep){

        loseH++;
      }
      if(dangerPlay)
      {

        loseH++;
      }
      if(loseH == 3 && this.petHealthLevel < 60){
        loseH = 1.6;
      }
      let dangerH = dangerFood || dangerPlay || dangerSleep;
      var el =this.shadowRoot.querySelector("#petEnv")
      this._calculateVisualAge();

      //Adjust graphics
      if(dangerH == true)
      {
        this.warnHealth(loseH);
        this.loseHealth(loseH);  
      }
      else
      {
        this.okHealth();
      }
      var timeEl = $(el).find(".time");
      $(timeEl).html(this._MillisecondsToDuration(this.petHealthLevel * (this.petHealthMax/100) * 1000));
      this._calculateProgress()

      if(dangerFood == true)
      {
        this.warnFood();      
      }
      else
      {
        this.okFood();
      }

      if(dangerPlay == true)
      {
        this.warnPlay();      
      }
      else
      {
        this.okPlay();
      }
  
      if(dangerSleep == true)
      {
        this.warnSleep();      
      }
      else
      {
        this.okSleep();
      }

      this.checkGym();
      
  
      //When your pet runs out of health, it will be a gonner.
      if(this.petHealthLevel <= 0){
          this.petAlive = false;
      }
      
      if(this.petAlive == false)
      {
        this.ending();
      }
      if(!this.isLoaded) this.loadedShow();  

    
  }

  _calculateVisualAge(){
    var age = Math.round(((this.petHealthMax - this.petHealthMaxInit)/this.petHealthMaxInit)*10+1);
    age = age > 8 ? 8 : age;
    this.petAge = age;

    this.petHappyImg = `${this.petVisualPath}happy/${age}.svg`;
    this.petSickImg = `${this.petVisualPath}sick/${age}.svg`;
    this.petSleepImg = `${this.petVisualPath}sleep/${age}.svg`;

    this.petHappyAn = `${this.petVisualPath}happy/${age}.json`;
    this.petSickAn = `${this.petVisualPath}sick/${age}.json`;
    this.petSleepAn = `${this.petVisualPath}sleep/${age}.json`;
  }


  _calculateProgress(){
    this.shadowRoot.querySelectorAll('.vertical .progress-fill span').forEach(function(fEl){
      //debugger;
      var percent = $(fEl).text();
      var pTop = 100 - ( percent.slice(0, percent.length - 1) ) + "%";
      $(fEl).parent().css({
        'height' : percent,
        'top' : pTop
      });
    });    
  }


  checkAnimation(){
    if(this.petCurrAn){
      this.isAnimationPresent = true;
      let animations = bodymovin.getRegisteredAnimations();
      if(animations.length > 0){
        let loaded = animations.find(x=>x.isLoaded === true);
        if(loaded){
          let loadedPath = `${loaded.path}${loaded.fileName}.json`;
          if(loadedPath !== this.petCurrAn){
            try{
              bodymovin.destroy();    
            }catch{}
            this.loadAnimation()
          }
        }
        else{
          try{
            bodymovin.destroy();    
          }catch{}

          this.loadAnimation();
        }
      }
      else{
        try{
          this.loadAnimation();
        }catch{}
        
      }
    }
    else{
      let animations = bodymovin.getRegisteredAnimations();
      if(animations.length > 0){
        try{
          bodymovin.destroy();        
        }catch{}
      }
      this.isAnimationPresent = false;
    }
  }

  loadAnimation(){
    var animeContainer = this.shadowRoot.getElementById('animeContainer');
    if(animeContainer){
      $(animeContainer).html("");
    }
    if(!(this.petCurrAn.indexOf('NaN.json') >  0)){
      var animItem = bodymovin.loadAnimation({
        wrapper: animeContainer,
        animType: 'svg',
        loop: true,
        path: this.petCurrAn
      });                 
  
    }

  }
  
  loseHealth(loseH){
    this.pulseHealth = this.getHealthPulse() + loseH * this.getHealthPulseStep();
    this.petHealthLevelExp = this.getHealthLevelExp();
    this.petHealthLevel = Math.round(this.petHealthLevelExp);

    
    let event = new CustomEvent('health-level-event', {
      detail: {
        message: `Health changed`
      }
    });
    this.dispatchEvent(event);
    

  }

  okHealth(){
    this.petState = this.petStates[0].Name;
    this.petCurrImg = this.isSleeping ? this.petSleepImg : this.petHappyImg;
    this.petCurrAn = this.isSleeping ? this.petSleepAn : this.petHappyAn;
    this.checkAnimation();

    var heartEl = this.shadowRoot.querySelector(".hearth");
    heartEl.classList.remove("sick");
    var detailsEl = this.shadowRoot.querySelector(".petDetails"); 
    for(var i = 1;i<=3;i++)
      detailsEl.classList.remove(`sick${i}`);
    if(this.petHealthLevel<100){
      this.pulseHealth = this.getHealthPulse() - this.getHealthPulseStep();
      this.petHealthLevelExp = this.getHealthLevelExp();
      this.petHealthLevel = Math.round(this.petHealthLevelExp);

      //this.petHealthLevel+=1;
      
      let event = new CustomEvent('health-level-event', {
        detail: {
          message: `Health changed`
        }
      });
      this.dispatchEvent(event);
      

    }
  }
  warnHealth(loseH){
    this.petState = this.petStates[1].Name;
    this.petCurrImg = this.isSleeping ? this.petSleepImg : this.petSickImg;
    this.petCurrAn = this.isSleeping ? this.petSleepAn : this.petSickAn;
    this.checkAnimation();
    var heartEl = this.shadowRoot.querySelector(".hearth");
    heartEl.classList.add("sick");
    var detailsEl = this.shadowRoot.querySelector(".petDetails"); 
    detailsEl.classList.add(`sick${loseH}`);
    
  }


  warnFood(){
    var foodEl = this.shadowRoot.querySelector(".food");
    foodEl.classList.add("sick");
  }
  okFood(){
    var foodEl = this.shadowRoot.querySelector(".food");
    foodEl.classList.remove("sick");
  }
  warnPlay(){
    var playEl = this.shadowRoot.querySelector(".play");
    playEl.classList.add("sick");
  }
  okPlay(){
    var playEl = this.shadowRoot.querySelector(".play");
    playEl.classList.remove("sick");
  }
  warnSleep(){
    var sleepEl = this.shadowRoot.querySelector(".sleep");
    sleepEl.classList.add("sick");
  }
  okSleep(){
    var sleepEl = this.shadowRoot.querySelector(".sleep");
    sleepEl.classList.remove("sick");
  }
  canGym(){
    var ret = true;
    if(this.lastGym !== undefined){
      var dt = new Date();
      var edge = this.lastGym + this.petHealthMax * 1000;
      if(dt.getTime()<=edge){
        ret = false;
      }
    }
    return ret;
  }
  checkGym(){
    var dt = (new Date()).getTime();
    var btnGym = this.shadowRoot.querySelector("#btnGym");
    if(btnGym){
      if(this.canGym() & !this.isSleeping){
        btnGym.removeAttribute("disabled");
      }
      else{
        $(btnGym).attr("disabled","disabled");
      }
      var gymBackTime = this.shadowRoot.querySelector("#btnGym .back-time")
      if(this.lastGym !== undefined){

        var edgeBack = this.lastGym + this.petHealthMax * 1000;
        if(edgeBack-dt>0){
          $(gymBackTime).html(this._MillisecondsToDuration(edgeBack-dt));
        }
        else{
          $(gymBackTime).html("00:00:00");  
        }
      }
      else{
        $(gymBackTime).html("00:00:00");
      }
  
    }
    
    var edge = this.lastGymDecrease + this.petHealthMaxInit *2 * 1000; // can be decreased if 2 healthMaxInit lost
    if(this.lastGym !== undefined && this.canGym() && dt > edge){
      this.petHealthMax = this.petHealthMax - this.petHealthMaxInit/10 >= this.petHealthMaxInit ? this.petHealthMax - this.petHealthMaxInit/10 :this.petHealthMaxInit;
      this.lastGymDecrease = dt;
      let event = new CustomEvent('gym-event', {
        detail: {
          message: `Gym changed`
        }
      });
      this.dispatchEvent(event);

    }

  }

  ending(){
    clearInterval(this.liveInterval);
    clearInterval(this.foodInterval);
    clearInterval(this.sleepInterval);
    clearInterval(this.playInterval);
    clearInterval(this.healthInterval);
    var controls = this.shadowRoot.querySelector(".friends");
    $(controls).hide();
    var heartEl = this.shadowRoot.querySelector(".hearth");
    heartEl.classList.add("stop");
    this.loseHealth(3);
    var timeEl = this.shadowRoot.querySelector(".time");
    timeEl.innerHTML = this._MillisecondsToDuration(0);

    this.okFood();
    this.okPlay();
    this.okSleep();
    this.petState = this.petStates[2].Name;
    this.isAnimationPresent = false;
    this.petCurrImg = this.petDiedImg;
    
    var diedEl = this.shadowRoot.querySelector(".wrap-died"); 
    diedEl.style.display="block";
    if(!this.isExt){
      var btnSleep = this.shadowRoot.querySelector("#btnSleep");
      var btnFeed = this.shadowRoot.querySelector("#btnFeed");
      var btnPlay = this.shadowRoot.querySelector("#btnPlay");
      var btnGym = this.shadowRoot.querySelector("#btnGym");
      var btnAwake = this.shadowRoot.querySelector("#btnAwake");
  
      $(btnSleep).attr("disabled", "disabled");
      $(btnFeed).attr("disabled", "disabled");
      $(btnPlay).attr("disabled", "disabled");
      $(btnGym).attr("disabled", "disabled");
      $(btnAwake).attr("disabled", "disabled");
  
    }
    this.petHealthLevel = 0;

    let event = new CustomEvent('died-event', {
      detail: {
        message: `${this.petName} died!`
      }
    });
    this.dispatchEvent(event);
    
    let that = this;
    this._updatePromise.then(res=>{
      var btnMakeNew = that.shadowRoot.querySelector("#btnMakeNew");
      let eventMakeNew = new CustomEvent('make-new-event', {
        detail: {
          message: `New pet requested`
        }
      });
      $(btnMakeNew).on("click", function(){
        that.dispatchEvent(eventMakeNew);
      });
  
    });
  }

  loadedShow(){
    var wrapper = this.shadowRoot.querySelector(".wrap-loading");
    $(wrapper).hide();
  }

  attributeChangedCallback(name, oldval, newval) {
    //console.log('attribute change: ', name, `${oldval}`, `${newval}`);
    super.attributeChangedCallback(name, oldval, newval);
    if(name==='petalive' && !this.petAlive){
      
      var that = this;
    }
  }
  
  _MillisecondsToDuration(milliseconds) {
    var n = Math.abs(milliseconds);
    var hms = "";
    var dtm = new Date();
    dtm.setTime(n);
    var d = Math.floor(n / 3600000 / 24); // KK-MOD
    var h = "0" + (Math.floor(n / 3600000) - (d * 24)); // KK-MOD
    var m = "0" + dtm.getMinutes();
    var s = "0" + dtm.getSeconds();
    var cs = "0" + Math.round(dtm.getMilliseconds() / 10);
    hms = (milliseconds < 0 ? " - " : "");
    hms += (d > 0 ? d + "." : "") + h.substr(h.length - 2) + ":" + m.substr(m.length - 2) + ":"; // KK-MOD
    hms += s.substr(s.length - 2);//+ "." + cs.substr(cs.length - 2);
    return hms; 
  }      

  handleFeed(urlFeed){
    if(this.isPopupMode) {
      chrome.tabs.create({ url: urlFeed, active: true });
    } else{
      $.redirect(urlFeed, {
        'categoryId': this.categoryId, 
        'itemId': this.itemId,
        'isSleeping': this.isSleeping,
        'petName':this.petName,
        'petHealthMax':this.petHealthMax,
        'petHealthMaxInit':this.petHealthMaxInit,
        'petHealthLevel':this.petHealthLevel,
        'petSleepLevel':this.petSleepLevel,
        'petPlayLevel':this.petPlayLevel,
        'petFoodLevel':this.petFoodLevel,
        'liveinDate':this.liveinDate,
        'petAlive':this.petAlive,
        'liveTime':this.liveTime,
        'lastGym':this.lastGym,
        'lastGymDecrease':this.lastGymDecrease
      });
    }  

  }


  //** Exp. functions for decay food, play, sleep, health **//
  getFoodLevelExp(){
    var t = this.pulseFood;
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/1152. : timeline/500);
    var factor2 = timeline/4.7;
    var leftInit = 100;
    var left = this.isSleeping 
        ? leftInit * Math.exp((factor1-t/5)/factor2)
        : leftInit * Math.exp((factor1-t/1.4)/factor2);
    if(left < 1){
      left = 0;
    }
    return left;
    
  }

  getFoodPulse(){
    var i = this.petFoodLevelExp;
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/1152. : timeline/500);
    var factor2 = timeline/4.7;
    var leftInit = 100;
    if(this.petFoodLevelExp === 0.0){
      return timeline;
    }
    if(this.isSleeping){
      return  5*(factor1 - factor2 * Math.log (i/leftInit));   
    }
    else{
      return  1.4* (factor1 - factor2 * Math.log (i/leftInit));   
    }
    
  }

  getFoodPulseStep(){
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/1152. : timeline/500);
    var factor2 = timeline/4.7;
    return Math.exp((factor1-timeline)/(factor2*2))
  }
 
  getPlayLevelExp(){
    var t = this.pulsePlay;
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/1352. : timeline/700);
    var factor2 = timeline/4.8;
    var leftInit = 100;
    var left = this.isSleeping
      ? this.petPlayLevelExp
      : leftInit * Math.exp((factor1-t/1.4)/factor2);
    if(left < 1){
      left = 0.0;
    }
    return left;
  }

  getPlayPulse(){
    var i = this.petPlayLevelExp;
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/1352. : timeline/700);
    var factor2 = timeline/4.8;
    var leftInit = 100;
    if(this.petPlayLevelExp === 0.0){
      return timeline;
    }
    if(this.isSleeping){
      return  this.pulsePlay;   
    }
    else{
      return  1.4*(factor1 - factor2 * Math.log (i/leftInit));   
    }
    
  }

  getPlayPulseStep(){
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/1352. : timeline/700);
    var factor2 = timeline/4.8;
    return Math.exp((factor1-timeline)/(factor2*2))
  }

  getSleepLevelExp(){
    var t = this.pulseSleep;
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/1152. : timeline/500);
    var factor2 = timeline/5.8;
    var leftInit = 100;
    var left = leftInit * Math.exp((factor1-t/1.4)/factor2);
    if(left < 1){
      left = 0;
    }
    if(left > 99.6){
      left = 99.6;
    }
    
    return left;
  }

  getSleepPulse(){
    var i = this.petSleepLevelExp;
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/1152. : timeline/500);
    var factor2 = timeline/5.8;
    var leftInit = 100;
    var ret = 1.4*(factor1 - factor2 * Math.log (i/leftInit))
    if(this.petSleepLevelExp === 0.0 || ret > timeline){
      ret = timeline;
    }
    return  ret;   
    
  }

  getSleepPulseStep(){
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/1152. : timeline/500);
    var factor2 = timeline/5.8;
    return Math.exp((factor1-timeline)/(factor2*2))
  }

  getHealthLevelExp(){
    var t = this.pulseHealth;
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/4152. : timeline/1000);
    var factor2 = timeline/4.9;
    var leftInit = 100;
    var left = leftInit * Math.exp((factor1-t/1.4)/factor2);
    if(left < 1){
      left = 0;
    }
    return left;
  }

  getHealthPulse(){
    var i = this.petHealthLevelExp;
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/4152. : timeline/1000);
    var factor2 = timeline/4.9;
    var leftInit = 100;
    if(this.petHealthLevelExp === 0.0){
      return timeline;
    }
    return  1.4*(factor1 - factor2 * Math.log (i/leftInit));   
    
  }

  getHealthPulseStep(){
    var timeline = this.petHealthMax;
    var factor1 = -(timeline>2310. ? timeline/4152. : timeline/1000);
    var factor2 = timeline/4.9;
    return Math.exp((factor1-timeline)/(factor2*2))
  }
}

customElements.define('virtual-pet', VirtualPet);
